import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  theme: {
    primary: '#5c444a',
    // primary: '#4d342c', // Variant A
    // primary: '#a43767', // Variant B
    // primary: '#38bca7', // Variant C
    // primary: '#A31F3E', // Variant D
    // secondary: '#f5e8eb', // Variant D
    // secondary: '#ECE0D9', // Variant A
    secondary: '#f4f3ec',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md',
});
